module.exports = __webpack_public_path__ + "img/3aed0e7.jpg";